import React from "react";

const TemplatePreview = ({ imgSrc }) => {
  return (
    <>
      <div className="voucher-image-preview text-center">
        <div className="">
          <img
            className="img img-fluid voucher-template-image"
            src={imgSrc ? imgSrc : null}
          />
        </div>
      </div>
    </>
  );
};

export default TemplatePreview;
